<style lang="scss"></style>

<template>
	<div style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">
		<div class="titleBar" style="display: flex;align-items:center ;position: sticky;top: 0;padding: 20px;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
				{{ $t('jbznhfb') }}
			</p>
		</div>
		<div ref="chartContent" :style="{ height: chartHeight + 'px' }" style="padding:0px 20px 20px 20px;flex:1;display: flex;justify-content: space-between;overflow: auto;">
			<div :style="{ height: chartHeight + 'px', width: chartHeight + 'px' }" style="position: relative;display: flex;justify-content: center;align-items: center;">
				<img style="position: absolute;" :style="{ height: chartHeight * 0.8 + 'px', width: chartHeight * 0.8 + 'px' }" src="../../../../../../assets/img/web/yzmtpf/yuanhuan.png" />

				<div id="tpfPie3" :style="{ height: chartHeight * 0.6 + 'px', width: chartHeight * 0.6 + 'px' }"></div>

				<div style="position: absolute;text-align: center;" :style="{ 'transform': 'scale(' + (chartHeight / 200) + ')' }">
					<p style="font-weight: 700;font-size: 18px;color: #FFFFFF;">{{ (parseFloat(datas.yearTotalEnergy[0]) + parseFloat(datas.yearTotalEnergy[1]) + parseFloat(datas.yearTotalEnergy[2])).toFixed(1) }}</p>
					<p style="font-weight: 400;font-size: 14px;color: #C6C6C6;">kWh</p>


				</div>

			</div>
			<div style="flex:1;display: flex;flex-direction: column;justify-content: center;margin-left: 20px;" :style="{ height: chartHeight + 'px' }">
				<div style="width: 100%;background: rgba(75, 112, 151, 0.1);border: 0.5px solid rgba(72, 109, 147, 0.3);display: flex;align-items: center;padding:4px 12px ;justify-content: space-between;">
					<div style="display: flex;align-items: center;">
						<div style="background: #0882FF;width: 18px;height: 18px;"></div>
						<p style="font-weight: 400;font-size: 16px;color: #C6C6C6;margin-left: 12px;">FF240</p>
					</div>
					<div style="display: flex;align-items: center;">
						<p style="font-weight: 700;font-size: 20px;color: #FFFFFF;">{{ datas.yearTotalEnergy[0] }}</p>
						<p style="font-weight: 400;font-size: 16px;margin-left: 4px;color: #C6C6C6;">kWh</p>
					</div>
				</div>

				<div style="width: 100%;background: rgba(75, 112, 151, 0.1);border: 0.5px solid rgba(72, 109, 147, 0.3);display: flex;align-items: center;padding:4px 12px ;justify-content: space-between;margin-top: 12px;">
					<div style="display: flex;align-items: center;">
						<div style="background: #E8FF38;width: 18px;height: 18px;"></div>
						<p style="font-weight: 400;font-size: 16px;color: #C6C6C6;margin-left: 12px;">UN160A5S</p>
					</div>
					<div style="display: flex;align-items: center;">
						<p style="font-weight: 700;font-size: 20px;color: #FFFFFF;">{{ datas.yearTotalEnergy[1] }}</p>
						<p style="font-weight: 400;font-size: 16px;margin-left: 4px;color: #C6C6C6;">kWh</p>
					</div>
				</div>

				<div style="width: 100%;background: rgba(75, 112, 151, 0.1);border: 0.5px solid rgba(72, 109, 147, 0.3);display: flex;align-items: center;padding:4px 12px ;justify-content: space-between;margin-top: 12px;">
					<div style="display: flex;align-items: center;">
						<div style="background: #05FB90;width: 18px;height: 18px;"></div>
						<p style="font-weight: 400;font-size: 16px;color: #C6C6C6;margin-left: 12px;">UN300MGII</p>
					</div>
					<div style="display: flex;align-items: center;">
						<p style="font-weight: 700;font-size: 20px;color: #FFFFFF;">{{ datas.yearTotalEnergy[2] }}</p>
						<p style="font-weight: 400;font-size: 16px;margin-left: 4px;color: #C6C6C6;">kWh</p>
					</div>
				</div>

			</div>

		</div>

	</div>
</template>
<script type="text/javascript">
export default {
	name: 'web_monitor_die_caster_pentu',
	components: {

	},
	props: {
		datas: {
			type: Object,
			default: () => {
				return {
					pentu: {}
				}
			}
		}
	},
	watch: {
		datas(newValue, oldValue) {
			if (this.utils.isEqual(newValue, oldValue)) {
				return;
			}
			this.makeChart();
		}
	},
	data() {
		return {
			timmer: null,
			chartHeight: 0,
			chart: null,
			option: null,

		};
	},
	created() {
		this.timmer = setInterval(() => {
		}, 120000)
	},
	mounted() {
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
		this.makeChart();
		this.resize();
	},

	destroyed() {
		clearInterval(this.timmer)
	},
	methods: {
		makeChart() {
			let data = [
				{
					value: this.datas.yearTotalEnergy[0],
					name: 'FF240',
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 1,
							y2: 0,
							colorStops: [
								{ offset: 0, color: '#0882FF' }, // 渐变起始颜色
								{ offset: 1, color: '#0882FF' }  // 渐变结束颜色
							]
						}
					}
				},
				{
					value: this.datas.yearTotalEnergy[1],
					name: 'UN160A5S',
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 1,
							y2: 0,
							colorStops: [
								{ offset: 0, color: '#E8FF38' },
								{ offset: 1, color: '#E8FF38' }
							]
						}
					}
				},
				{
					value: this.datas.yearTotalEnergy[2],
					name: 'UN300MGII',
					itemStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 1,
							y2: 0,
							colorStops: [
								{ offset: 0, color: '#05FB90' },
								{ offset: 1, color: '#05FB90' }
							]
						}
					}
				}
			]
			// this.chartHeight = this.$refs.container.offsetHeight - this.$refs.top.offsetHeight - this.$refs.title.offsetHeight - 40;
			if (!this.chart) {
				this.initChart();
			}
			this.option.series[0].data = data;
			this.chart.setOption(this.option);

		},
		initChart() {
			this.option = {
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				legend: {
					show: false,
					top: 'bottom'
				},
				series: [
					{
						name: '能耗排放',
						type: 'pie',
						radius: ['80%', '100%'],
						itemStyle: {
							// 统一设置间隔样式
							borderWidth: 3,      // 间隔线宽度
							borderColor: '#26262a'  // 间隔线颜色（需与背景色一致）
						},
						label: {
							show: false,
							formatter: '{b}: {d}%'
						},
						data: [
							{
								value: 335,
								name: 'FF240',
								itemStyle: {
									color: {
										type: 'linear',
										x: 0,
										y: 0,
										x2: 1,
										y2: 0,
										colorStops: [
											{ offset: 0, color: '#FF6B6B' }, // 渐变起始颜色
											{ offset: 1, color: '#FFA8A8' }  // 渐变结束颜色
										]
									}
								}
							},
							{
								value: 310,
								name: 'UN160A5S',
								itemStyle: {
									color: {
										type: 'linear',
										x: 0,
										y: 0,
										x2: 1,
										y2: 0,
										colorStops: [
											{ offset: 0, color: '#4D95FF' },
											{ offset: 1, color: '#99C2FF' }
										]
									}
								}
							},
							{
								value: 234,
								name: 'UN300MGII',
								itemStyle: {
									color: {
										type: 'linear',
										x: 0,
										y: 0,
										x2: 1,
										y2: 0,
										colorStops: [
											{ offset: 0, color: '#6BFF6B' },
											{ offset: 1, color: '#A8FFA8' }
										]
									}
								}
							}
						]
					}
				]
			};

			var chartDom = document.getElementById('tpfPie3');
			this.chart = this.echarts.init(chartDom);
			this.option && this.chart.setOption(this.option);
		},
		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {
				if (!this.$refs.chartContent) {
					return;
				}
				this.chartHeight = this.$refs.chartContent.offsetHeight - 20;
				setTimeout(() => {
					if (this.chart != null) {
						this.chart.resize();
					}
				}, 0);
			}, 500);
		}
	}
};
</script>
